import React, { useState } from 'react'
import { useAuthFromContext } from '../AuthContext'
import HogTitleGroup from './HogTitleGroup'
import './SignInScreen.css'

export default function SignInScreen() {
  const { sendMagicLink, signInAsGuest, needsEmailForLink, completeLinkSignIn } = useAuthFromContext()
  const [email, setEmail] = useState('')
  const [phase, setPhase] = useState(needsEmailForLink ? 'crossdevice' : 'idle')
  const [error, setError] = useState('')

  async function handleSendLink(e) {
    e.preventDefault()
    if (!email) return
    setPhase('sending')
    setError('')
    const result = await sendMagicLink(email)
    if (result.success) {
      setPhase('sent')
    } else {
      setError(result.error)
      setPhase('idle')
    }
  }

  async function handleCompleteLink(e) {
    e.preventDefault()
    if (!email) return
    setPhase('sending')
    setError('')
    const result = await completeLinkSignIn(email)
    if (!result.success) {
      setError(result.error)
      setPhase('crossdevice')
    }
  }

  if (phase === 'sent') {
    return (
      <div className="signin-screen">
        <HogTitleGroup titleClassName="signin-title" />
        <div className="signin-card">
          <p className="signin-sent-heading">Check your email</p>
          <p className="signin-sent-sub">A sign-in link was sent to <strong>{email}</strong></p>
          <button className="signin-btn-ghost" onClick={() => { setPhase('idle'); setEmail('') }}>
            Use a different email
          </button>
        </div>
      </div>
    )
  }

  if (phase === 'crossdevice') {
    return (
      <div className="signin-screen">
        <HogTitleGroup titleClassName="signin-title" />
        <div className="signin-card">
          <label className="signin-label">Confirm your email to sign in</label>
          <form onSubmit={handleCompleteLink}>
            <input
              className="signin-input"
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="your@email.com"
              autoFocus
              autoComplete="email"
            />
            {error && <p className="signin-error">{error}</p>}
            <button
              className="signin-btn-primary"
              type="submit"
              disabled={!email || phase === 'sending'}
            >
              {phase === 'sending' ? 'Signing in…' : 'Sign in'}
            </button>
          </form>
        </div>
      </div>
    )
  }

  return (
    <div className="signin-screen">
      <HogTitleGroup titleClassName="signin-title" />
      <div className="signin-card">
        <label className="signin-label">Sign in with email</label>
        <form onSubmit={handleSendLink}>
          <input
            className="signin-input"
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="your@email.com"
            autoFocus
            autoComplete="email"
          />
          {error && <p className="signin-error">{error}</p>}
          <button
            className="signin-btn-primary"
            type="submit"
            disabled={!email || phase === 'sending'}
          >
            {phase === 'sending' ? 'Sending…' : 'Send magic link'}
          </button>
        </form>
        <div className="signin-divider"><span>or</span></div>
        <button className="signin-btn-ghost" onClick={signInAsGuest}>
          Play as guest
        </button>
      </div>
    </div>
  )
}
